import { lazy } from "react";
import { Flag } from "lucide-react";
import type { AdminModule } from "../types";

const FlagsList = lazy(() => import("./pages/FlagsList").then((m) => ({ default: m.FlagsList })));

/**
 * RFC-460 — Feature-flag plane admin UI. List view with quick-toggle for
 * booleans + per-env values + audit drawer. Detail / overrides editor
 * lands in Phase 2b.2 once we have a use case beyond signup.ai_orb.
 *
 * The route key is kebab-case like every other route in the app; the folder
 * keeps its underscore so the move stays a rename in git rather than a delete
 * and an add.
 */
export const featureFlagsModule: AdminModule = {
  key: "feature-flags",
  label: "Feature flags",
  description: "Per-environment and per-business toggles, with their audit trail.",
  group: "services",
  icon: Flag,
  routes: [{ path: "", label: "Flags", element: <FlagsList /> }],
};
